import React, { PropsWithChildren } from 'react'
import { Form as FormikForm,FormikContextType, FormikProvider } from 'formik'

type FormProps<T> = PropsWithChildren<{
  className?: string;
  formik: FormikContextType<T>
}>;

export const Form = <T,>({ formik, className, children }: FormProps<T>) => (
    <FormikProvider value={formik}>
      <FormikForm className={className} onSubmit={formik.handleSubmit}>
        {children}
      </FormikForm>
    </FormikProvider>
  )
